import React from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="border-t border-cream-100 mt-16 py-10 bg-white/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-3" data-testid="footer-logo">
              <img src="/logo-horizontal.png" alt="{Beauty} Stashmart" className="h-8 w-auto select-none" draggable={false} />
              <span className="bg-[#F4C2C2] text-[#2C2A29] text-[9px] font-body font-bold px-1.5 py-0.5 rounded-full">BETA</span>
            </Link>
            <p className="font-body text-xs text-[#A89F91] leading-relaxed">
              Where beauty finds its next chapter.
            </p>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-heading text-sm text-[#2C2A29] font-semibold mb-3">Company</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="font-body text-xs text-[#78716C] hover:text-[#2C2A29] transition-colors" data-testid="footer-about">About Us</Link></li>
              <li><Link to="/contact" className="font-body text-xs text-[#78716C] hover:text-[#2C2A29] transition-colors" data-testid="footer-contact">Contact</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-heading text-sm text-[#2C2A29] font-semibold mb-3">Legal</h4>
            <ul className="space-y-2">
              <li><Link to="/terms" className="font-body text-xs text-[#78716C] hover:text-[#2C2A29] transition-colors" data-testid="footer-terms">Terms &amp; Conditions</Link></li>
              <li><Link to="/privacy" className="font-body text-xs text-[#78716C] hover:text-[#2C2A29] transition-colors" data-testid="footer-privacy">Privacy Policy</Link></li>
              <li><Link to="/refund-policy" className="font-body text-xs text-[#78716C] hover:text-[#2C2A29] transition-colors" data-testid="footer-refund">Refund Policy</Link></li>
              <li><Link to="/faq" className="font-body text-xs text-[#78716C] hover:text-[#2C2A29] transition-colors" data-testid="footer-faq">FAQs</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-sm text-[#2C2A29] font-semibold mb-3">Contact</h4>
            <a href="mailto:hello@stashmart.store" className="flex items-center gap-2 font-body text-xs text-[#78716C] hover:text-[#D48585] transition-colors" data-testid="footer-email">
              <Mail size={14} /> hello@stashmart.store
            </a>
            <div className="mt-3 space-y-1">
              <p className="font-body text-xs text-[#A89F91]">Instagram: <a href="https://www.instagram.com/beautystashmart?igsh=MXg0ODFvY2ppeXJmNg==" target="_blank" rel="noopener noreferrer" className="text-[#78716C] hover:text-[#D48585] transition-colors" data-testid="footer-instagram">@beautystashmart</a></p>
              <p className="font-body text-xs text-[#A89F91]">TikTok: <span className="italic">coming soon</span></p>
            </div>
          </div>
        </div>

        <div className="border-t border-cream-100 pt-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="font-body text-xs text-[#A89F91]">&copy; {new Date().getFullYear()} {'{'}Beauty{'}'} Stashmart. All rights reserved.</p>
          <p className="font-body text-xs text-[#A89F91]">Payments secured by Duitku</p>
        </div>
      </div>
    </footer>
  );
}
